import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import * as FileSaver from "file-saver"
import _ from 'lodash'
import moment from 'moment'
import numeral from 'numeral'
import helpers from 'helpers/helpers'
import settings from 'settings'
import { setTableExporting } from "actions"

class ExcelOnly extends Component {

    constructor(props) {
        super(props)
    }

    handle = async () => {
		let data = this.props.data
		let set = _.cloneDeep(data)
		//console.log(set)
        let f = []
        // Remove react-table crud
        _.forEach(set, v => {
            let row = v
            //console.log(row)
            // Remove columns from this.props.unset
            if(this.props.unset) {
                _.forEach(this.props.unset, us => {
                    _.unset(row, us)
                })
			}
			_.forEach(row, (r,k) => {
				if (typeof r === "number" && k.toLowerCase().includes("date")) {
					row[k] = moment.unix(r).format("MM/DD/YY")
				}
				else if(typeof r === 'number' && r > 946706400) {
					//! The number above is for 1/1/2000.  Numbers shouldn't ever get that high for prices and the like, so it's probably a timestamp.  Leaving a note in case this comes up.
					row[k] = moment.unix(r).format("MM/DD/YY")
				}
				else if (k.toLowerCase().includes("percent")) {
					row[k] = numeral(r / 100).format("0.00%")
				} else if (r && typeof r !== "string" && !isNaN(r) && Number.isInteger(r)) {
					//row[k] = numeral(r).format('0,0')
				}
			})
            f.push(row)
		})
		f = helpers.translateTable(f)
		// Run utils, if any
		//? Not in use, but could be useful.
		if(this.props.utils) {
			_.forEach(this.props.utils, v => {
				f = helpers[v](f) 
			})
		}
		//console.log(f)
		//return
		const { default: XLSX } = await import("xlsx")
        const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
        const fileExtension = ".xlsx"
        const ws = XLSX.utils.json_to_sheet(f)
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] }
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" })
        const d = new Blob([excelBuffer], { type: fileType })
        FileSaver.saveAs(d, `${settings.name}-` + this.props.title + fileExtension)
	}
	
	formatData = data => {
		// Run the data through ReactTable's Cell formatter, so we get $387,998 vs. 387998
		_.forEach(data.columns, (v) => {
			if(!v.Cell) { return }
			_.forEach(data.sortedData, r => {
				r.original = r._original
				r[v.accessor] = v.Cell({value: r[v.accessor]})
			})
		})
		// Get rid of reactable shit
		_.forEach(data.sortedData, v => {
			_.forEach(v, (r,k) => {
				if(k.substr(0, 1) == '_' || k == 'original') {
					delete v[k]
				}
			})	
		})

		return data.sortedData
	}

	render() {
		return (
			<div className="excel">
				<i
					className="fad fa-file-excel"
					data-html2canvas-ignore="true"
					title="Export to Excel"
					onClick={this.handle}
				/>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({
		setTableExporting
	}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ExcelOnly)
